import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { NotFoundComponent, BaseRoutes, MainContainerComponent } from '@nts/std';
import { EmptyContainerComponent } from '@nts/std';
import { environment } from 'src/environments/environment';

const title = environment ? environment.appTitle : 'Application Title';

const routes: Routes = [
  // #region rotte con autenticazione
  ...BaseRoutes.getBaseAuthentictedRoutes(
    environment,
    [
      ...BaseRoutes.getEntityRoutes(
        title,
        'schedule',
        () => import('./schedule/schedule.module').then(m => m.ScheduleModule)
      ),
      ...BaseRoutes.getEntityRoutes(
        title,
        'scheduledata',
        () => import('./schedule-data/schedule-data.module').then(m => m.ScheduleDataModule)
      ),
      ...BaseRoutes.getEntityRoutes(
        title,
        'scheduleplandata',
        () => import('./schedule-plan-data/schedule-plan-data.module').then(m => m.SchedulePlanDataModule)
      ),
      ...BaseRoutes.getEntityRoutes(
        title,
        'executions',
        () => import('./executions/executions.module').then(m => m.ExecutionsModule)
      ),
      ...BaseRoutes.getDefaultRoutes(
        title,
        environment,
        true
      )
    ]
  ),
  // #endregion rotte con autenticazione

  // rotte base per la gestione degli errori
  ...BaseRoutes.getBaseErrorsRoute()
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes),
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
